import _extends from "@babel/runtime-corejs3/helpers/extends";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, VNode, render, createVNode as h } from 'intact-vue-next';
import template from './message.vdt';
import { Messages } from './messages';
import { useDelayClose } from '../../hooks/useDelayClose';
import { isObject } from 'intact-shared';
import { bind } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  content: [String, VNode],
  duration: Number,
  type: ['info', 'error', 'success', 'warning'],
  closable: Boolean,
  hideIcon: Boolean
};
var id = 0;
var defaults = function defaults() {
  return {
    duration: 5000,
    type: 'info',
    closable: false
  };
};
var messages = null;
export var Message = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Message, _Component);
  function Message() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.delayClose = useDelayClose(_this.close, _this.get('duration'));
    _this.config = useConfigContext();
    return _this;
  }
  Message.notice = function notice(content, duration, type) {
    if (duration === void 0) {
      duration = 3000;
    }
    if (type === void 0) {
      type = 'info';
    }
    if (isObject(content) && !content.tag) {
      content = _extends({}, content, {
        type: type,
        key: id++
      });
    } else {
      content = {
        content: content,
        duration: duration,
        type: type,
        key: id++
      };
    }
    if (!messages) {
      var container = document.createElement('div');
      document.body.append(container);
      render(h(Messages, {
        ref: function ref(i) {
          return messages = i;
        },
        classNamePrefix: Message.classNamePrefix
      }), container);
    }
    messages.notice(h(Message, content));
  };
  Message.info = function info(content, duration) {
    Message.notice(content, duration, 'info');
  };
  Message.error = function error(content, duration) {
    Message.notice(content, duration, 'error');
  };
  Message.success = function success(content, duration) {
    Message.notice(content, duration, 'success');
  };
  Message.warning = function warning(content, duration) {
    Message.notice(content, duration, 'warning');
  };
  var _proto = Message.prototype;
  _proto.close = function close() {
    messages.delete(this.get('key'));
  };
  return Message;
}(Component);
Message.template = template;
Message.typeDefs = typeDefs;
Message.defaults = defaults;
Message.classNamePrefix = void 0;
__decorate([bind], Message.prototype, "close", null);